module.exports = "https://p.cds.unp.clasificados.pe/montserrat-bold.e9f3813c3d7f810a6de6c38257786944.woff2";